[
    {
        "Index Id": {
            "editable": false,
            "refData": {
                "datatype": "numberGroup"
            },
            "lockVisible": true,
            "hide": false,
            "checkboxSelection": true,
            "headerCheckboxSelection": true,
            "headerCheckboxSelectionFilteredOnly": true,
            "lockPosition": true,
            "pinned": "left",
            "lockPinned": true
        },
        "Job Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "flexSize": 2,
                "minWidth": 200
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Product Node": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Channel": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Prior Selling Season(s)": {
            "editable": false,
            "refData": {
                "datatype": "array",
                "arrayKey": "season",
                "customNullValue": "Custom Season",
                "showToolTip": false,
                "custom_field": "prior_selling_seasons"
            },
            "rowGroup": false,
            "hide": false
        },
        "Buying Season": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Use Aug Sales": {
            "editable": false,
            "refData": {
                "datatype": "boolean",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "VG Count": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Attribute Family": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Attribute Value": {
            "editable": false,
            "refData": {
                "datatype": "storeIndexAttrValueArray",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Sales Units": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "replaceZeros": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Edited": {
            "editable": false,
            "refData": {
                "datatype": "boolean",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Last Modified": {
            "editable": false,
            "refData": {
                "datatype": "date",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "sort": "desc"
        },
        "Last Modified By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": true
        },
        "Status(es)": {
            "editable": false,
            "refData": {
                "datatype": "statusesArray",
                "custom_field": "statuses"
            },
            "hide": false
        },
        "Output": {
            "editable": false,
            "refData": {
                "displayBlankHeader": true,
                "datatype": "open-screen|output",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Edit": {
            "editable": false,
            "refData": {
                "displayBlankHeader": true,
                "headerRendererIcon": false,
                "datatype": "open-screen|settings",
                "showToolTip": false,
                "toolTipMessage": "View/Edit"
            },
            "rowGroup": false,
            "hide": false
        }
    },
    {
        "Index Id": {
            "editable": false,
            "refData": {
                "datatype": "string"
            },
            "hide": false,
            "checkboxSelection": true,
            "resizable": true,
            "lockPosition": true,
            "pinned": "left"
        },
        "Job Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "flexSize": 2,
                "minWidth": 200
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Product Node": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Channel": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Prior Selling Season(s)": {
            "editable": false,
            "refData": {
                "datatype": "array",
                "arrayKey": "season",
                "customNullValue": "Custom Season",
                "showToolTip": false,
                "custom_field": "prior_selling_seasons"
            },
            "rowGroup": false,
            "hide": false
        },
        "Buying Season": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Use Aug Sales": {
            "editable": false,
            "refData": {
                "datatype": "boolean",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "VG Count": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Attribute Family": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Attribute Value": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Sales Units": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "replaceZeros": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Edited": {
            "editable": false,
            "refData": {
                "datatype": "boolean",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Last Modified": {
            "editable": false,
            "refData": {
                "datatype": "date",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Last Modified By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": true
        },
        "Status": {
            "editable": false,
            "refData": {
                "datatype": "string"
            },
            "hide": false
        }
    }
]
